import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';

export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store<StoreState>);
  const impersonationToken = store.selectSignal(userSelectors.impersonationToken)();
  if (impersonationToken != null) {
    return next(
      req.clone({
        setHeaders: {
          Authorizationimp: impersonationToken,
        },
      })
    );
  }
  return next(req);
};
